var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpUserforum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 29.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-help-userforum") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.1,22.86a3.42,3.42,0,0,0,3,2.62A3.41,3.41,0,0,0,18,22.86a1.88,1.88,0,0,0,.47-2.48c1.12-5.25-8-5.25-6.84,0A1.89,1.89,0,0,0,12.1,22.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.19,24.5A4,4,0,0,1,15,26.42a4,4,0,0,1-3.19-1.92c-.42.28-3.94.94-3.75,5a.46.46,0,0,0,.47.42H21.42a.46.46,0,0,0,.47-.42C22.12,25.49,18.65,24.78,18.19,24.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.53,23.14a3.48,3.48,0,0,1-6.18,0c-.42.28-.7.19-1.5.7a5.46,5.46,0,0,1,4,4.5h6.7a.46.46,0,0,0,.47-.42A4.47,4.47,0,0,0,26.53,23.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.67,21.6a3.7,3.7,0,0,0,2,2.34c1.55.66,3.09-.75,3.56-2.34a1.8,1.8,0,0,0,.47-2.39c.66-3-2.39-4.4-4.92-3.37a2.79,2.79,0,0,0-1.59,3.37A1.82,1.82,0,0,0,20.67,21.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.8,21.6a3.28,3.28,0,0,0,2.76,2.48A3.28,3.28,0,0,0,9.33,21.6a1.8,1.8,0,0,0,.47-2.39c1-5-7.54-5-6.51,0A1.89,1.89,0,0,0,3.8,21.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.21,23.8a9.7,9.7,0,0,0-1.55-.7A3.82,3.82,0,0,1,6.57,25,3.93,3.93,0,0,1,3.47,23.1c-.47.28-3.65,1-3.47,4.73a.46.46,0,0,0,.47.42H7.22C7.6,25.67,9.05,24.83,11.21,23.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.42,6.37V7.59a.49.49,0,0,0,.7.42l1.73-.94c2.86.37,6.14-1,6.14-3.51C30,1.59,27.65,0,24.7,0s-5.25,1.59-5.25,3.56A3.32,3.32,0,0,0,21.42,6.37ZM25.35,2.9h1.5V4.4h-1.5Zm-2.81,0H24V4.4h-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.15,7.12l1.73.94a.47.47,0,0,0,.7-.42V6.42a3.24,3.24,0,0,0,2-2.81c0-2-2.3-3.56-5.29-3.56S0,1.59,0,3.56C0,6.09,3.24,7.45,6.15,7.12ZM5.91,2.9h1.5V4.4H5.91ZM3.1,2.9H4.6V4.4H3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.62,13.26V9.09a.94.94,0,0,0-.94-.94H10.32a.94.94,0,0,0-.94.94v4.17a.94.94,0,0,0,.94.94h3.23l1.12,1.12a.45.45,0,0,0,.66,0l1.12-1.12h3.23A.94.94,0,0,0,20.62,13.26Zm-6.28-1.41h-1.5v-1.5h1.5Zm2.81,0h-1.5v-1.5h1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpUserforum);
export default __webpack_public_path__ + "static/media/icon-help-userforum.d7d82a566876d05483ca62a3b106761b.svg";
export { ForwardRef as ReactComponent };